import { apiGet, apiPost, apiPut, apiDelete, unwrap } from './apiClient';
import { ResponseDTO, LdapSettingDTO } from '@/types/api';

const BASE = '/api/v1/ldap';

export async function createLdapSetting(setting: LdapSettingDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<string>>(BASE, setting);
  return unwrap(res);
}

export async function listLdapSettings(): Promise<LdapSettingDTO[]> {
  const res = await apiGet<ResponseDTO<LdapSettingDTO[]>>(BASE);
  return unwrap(res);
}

export async function getLdapSetting(id: string): Promise<LdapSettingDTO> {
  const res = await apiGet<ResponseDTO<LdapSettingDTO>>(`${BASE}/${id}`);
  return unwrap(res);
}

export async function updateLdapSetting(id: string, setting: LdapSettingDTO): Promise<string> {
  const res = await apiPut<ResponseDTO<string>>(`${BASE}/${id}`, setting);
  return unwrap(res);
}

export async function deleteLdapSetting(id: string): Promise<void> {
  await apiDelete<ResponseDTO<null>>(`${BASE}/${id}`);
}

export async function getLdapByDomain(emailDomain: string): Promise<LdapSettingDTO> {
  const res = await apiGet<ResponseDTO<LdapSettingDTO>>(`${BASE}/by-domain/${emailDomain}`);
  return unwrap(res);
}

export async function testLdapConnection(setting: LdapSettingDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<null>>(`${BASE}/test-connection`, setting);
  return res.message || 'Connection successful';
}

export async function triggerLdapSync(id: string): Promise<string> {
  const res = await apiPost<ResponseDTO<string>>(`${BASE}/${id}/sync`);
  return unwrap(res);
}
